import type { GameState } from './types.js'

// Deliberately a string property: object spread, structuredClone and JSON round
// trips preserve it. A WeakSet or Symbol alone would lose the guard on cloning.
const MARKER = '__warcarpHypothetical' as const
type Tagged = { [MARKER]?: true }

/** Tag both the branch and its events: either can otherwise escape separately. */
export function markHypotheticalState(state: GameState): GameState {
  return Object.assign({}, state, {
    [MARKER]: true as const,
    events: state.events?.map((event) => Object.assign({}, event, { [MARKER]: true as const })),
  })
}

/** Shared live-boundary guard, checked before any DB transaction or wire serialization. */
export function assertObservedState(state: GameState, events = state.events ?? []): void {
  const taggedEvent = (event: NonNullable<GameState['events']>[number]) => (event as typeof event & Tagged)[MARKER]
  if ((state as GameState & Tagged)[MARKER] || state.events?.some(taggedEvent) ||
      (events !== state.events && events.some(taggedEvent))) {
    throw new Error('Hypothetical search state/events cannot be persisted or broadcast')
  }
}
